import { render, staticRenderFns } from "./BlacklistRegistrationPopup.vue?vue&type=template&id=75a0abac&"
import script from "./BlacklistRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./BlacklistRegistrationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports